export const ROLES = {
    ADMINISTRADOR: 'ADMINISTRADOR',
    SUSCRIPTOR: 'SUSCRIPTOR',
    COMERCIAL: 'COMERCIAL',
    PRODUCTOR: 'PRODUCTOR',
    AGENTE: 'AGENTE'
};

// Guardamos todos los roles en un array para darles acceso total por el momento
const TODOS_LOS_ROLES = Object.values(ROLES);

/**
 * Matriz de Control de Acceso (ACL)
 * Seteamos TODOS_LOS_ROLES en cada módulo para que por el momento nadie vea bloqueada ninguna pantalla.
 * VER_PANEL_ADMIN queda estrictamente bloqueado para uso exclusivo del ADMINISTRADOR.
 */
export const PERMISSIONS = {
    // Vistas generales de control
    VER_PANEL_ADMIN: [ROLES.ADMINISTRADOR], // ◄ Estrictamente restringido al Administrador
    VER_IMPORTADOR_DEUDA: TODOS_LOS_ROLES,
    VER_REPORTES_AVANZADOS: TODOS_LOS_ROLES,
    
    // Módulos operativos de Emisión de Pólizas
    CREAR_EMISION: TODOS_LOS_ROLES,
    EDITAR_EMISION: TODOS_LOS_ROLES,
    ELIMINAR_EMISION: TODOS_LOS_ROLES,
    
    // Módulos operativos de Cotizaciones ART
    CREAR_COTIZACION: TODOS_LOS_ROLES,
    PEDIR_COTIZACION: TODOS_LOS_ROLES,
    VER_GESTION_AUMENTOS: TODOS_LOS_ROLES,     
    VER_IMPORTADOR_AUMENTOS: TODOS_LOS_ROLES,  
};

/**
 * checkPermission - Valida si un rol tiene acceso a una acción.
 */
export const checkPermission = (userRole, action) => {
    const rolesWithAccess = PERMISSIONS[action];
    if (!rolesWithAccess) return false;
    
    // ◄ BLINDAJE CRÍTICO: Si la acción es VER_PANEL_ADMIN, obligamos a que el rol esté definido y sea ADMINISTRADOR
    if (action === 'VER_PANEL_ADMIN') {
        if (!userRole) return false;
        const normalizedUserRole = String(userRole).toUpperCase().trim();
        return rolesWithAccess.some(r => r.toUpperCase() === normalizedUserRole);
    }
    
    // Si por algún motivo el rol no viene o es un usuario nuevo (y no es el panel de administración),
    // por defecto le permitimos pasar para que la única restricción de la UI sea la de Solo Lectura.
    if (!userRole) return true; 
    
    const normalizedUserRole = String(userRole).toUpperCase().trim();
    return rolesWithAccess.some(r => r.toUpperCase() === normalizedUserRole) || rolesWithAccess === TODOS_LOS_ROLES;
};

const permissionsModule = {
    ROLES,
    PERMISSIONS,
    checkPermission
};

export default permissionsModule;